import clsx from 'clsx';
import React from 'react';

type Props = {
  variant?: 'xs' | 'small' | 'medium' | 'large' | 'label' | 'title-lg';
  classes?: string;
  children: React.ReactNode;
};

const variantClasses = (variant: Props['variant']) =>
  clsx({
    'body-sm': variant === 'xs',
    'text-sm font-normal leading-normal': variant === 'small',
    'body-lg': variant === 'medium',
    'text-lg font-light leading-8': variant === 'large',
    'label-lg': variant === 'label',
    'title-lg': variant === 'title-lg',
  });

const extractHtmlString = (children: React.ReactNode): string | null => {
  if (typeof children === 'string') return children;
  if (Array.isArray(children) && children.every((c) => typeof c === 'string')) return children.join('');
  return null;
};

const looksLikeDivEmbed = (html: string) => /<div\b[^>]*>[\s\S]*<\/div>/i.test(html.trim());

const Paragraph = ({ variant = 'medium', classes = 'text-neutral-10', children }: Props) => {
  const html = extractHtmlString(children);

  // If children is an HTML string with a div embed, render it as real HTML (div -> div)
  if (html && looksLikeDivEmbed(html)) {
    return <div className={clsx(classes, variantClasses(variant))} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  // Normal text rendering
  return <p className={clsx(classes, variantClasses(variant))}>{children}</p>;
};

export default Paragraph;
